import { Column, NumericEditCell, IGrid, getObject, isEditable, getComplexFieldID, IIndex } from "@syncfusion/ej2-angular-grids";
import { FieldEditChangedArgs, FieldMetadata, FieldMetadataUtil } from "../cer-data/cer-data-types";
import { CerLocaleService } from "@ui/cer-ui-locale.service";
import { NumericTextBox } from "@syncfusion/ej2-angular-inputs";
import { EventHandler, extend } from "@syncfusion/ej2-base";

export class CerGridEditNumeric {
  private grid: any;
  private fieldMeta: FieldMetadata;
  private fieldsMeta: FieldMetadata[];
  private baseEditCell: NumericEditCell;
  private baseEditCellAny: any;
  private input: HTMLInputElement;
  private obj: NumericTextBox;
  private rowData: any;
  private noUpDown: boolean;

  constructor(grid: IGrid, baseEditCell: NumericEditCell, fieldMeta: FieldMetadata, fieldsMeta: FieldMetadata[], private localeService: CerLocaleService) {
    this.grid = grid;
    this.baseEditCell = baseEditCell;
    this.baseEditCellAny = <any>baseEditCell;
    this.fieldMeta = fieldMeta;
    this.fieldsMeta = fieldsMeta;

    (<any>baseEditCell).create_orig = baseEditCell.create;
    this.baseEditCell.create = this.create.bind(this);

    (<any>baseEditCell).destroy_orig = baseEditCell.destroy;
    baseEditCell.destroy = this.destroy.bind(this);

    (<any>baseEditCell).write_orig = baseEditCell.write;
    baseEditCell.write = this.write.bind(this);

    (<any>baseEditCell).read_orig = baseEditCell.read;
    baseEditCell.read = this.read.bind(this);
  }

  public create(args: any): any {
    if (this.baseEditCellAny.create_orig) {
      this.input = this.baseEditCellAny.create_orig(args);
      return this.input;
    }
  }

  public write(args: {
    rowData: Object;
    element: Element;
    column: Column;
    requestType: string;
    row: Element;
  }) {
    this.noUpDown = FieldMetadataUtil.hasFormat('NoUpDown', this.fieldMeta);
    this.rowData = args.rowData;
    // -> standard
    var col = args.column;
    var isInline = this.grid.editSettings.mode !== 'Dialog';
    this.baseEditCellAny.obj = new NumericTextBox(extend({
      value: parseFloat(getObject(args.column.field, args.rowData)),
      enableRtl: this.grid.enableRtl,
      placeholder: isInline ? '' : args.column.headerText,
      enabled: isEditable(args.column, args.requestType, args.element),
      floatLabelType: this.grid.editSettings.mode !== 'Dialog' ? 'Never' : 'Always',
      locale: this.grid.locale,
      cssClass: this.grid.cssClass ? this.grid.cssClass : null
    }, col.edit.params));
    args.element.setAttribute('name', getComplexFieldID(args.column.field));
    // <- standard
    this.obj = this.baseEditCellAny.obj;
    this.obj.showSpinButton = false; // this.noUpDown controls up down key (spin buttons are never shown)
    this.obj.cssClass = "numeric-align";
    this.obj.showClearButton = this.fieldMeta?.allowClear !== false;
    // -> standard
    this.obj.appendTo(<HTMLElement>args.element);
    this.obj.element.addEventListener('keydown', this.baseEditCellAny.keyEventHandler);
    // <- standard

    this.cerEventListenerAdd();
  }

  public keyDownHandlerUpDown(event: any) {
    const isUp: boolean = (event.keyCode === 38);
    const isDown: boolean = (event.keyCode === 40);
    if (!isUp && !isDown) {
      return;
    }
    // Scope: this = caller HTMLInputElement
    const element: HTMLInputElement = <HTMLInputElement><any>event.currentTarget;
    const numericEdit = this.obj;
    if (!numericEdit) {
      return;
    }
    (<any>numericEdit).changeHandler(event);

    const content = this.grid.focusModule.getContent()
    if ((isUp && content.matrix.current[0] == 0) ||
        (isDown && content.matrix.current[0] == content.matrix.rows)) {
      return;
    }
    event.action = isUp ? 'upArrow' : 'downArrow';
    content.onKeyPress(event);
    const idx: IIndex = {
      rowIndex: content.matrix.current[0],
      cellIndex: content.matrix.current[1]
    };
    this.grid.selectionModule.selectCell(idx, false)
  }

  public destroy() {
    this.cerEventListenerRemove();
    if (this.baseEditCellAny.destroy_orig && 
        this.baseEditCellAny.obj && 
        this.obj &&
        (<any>this.obj).hiddenInput) {
      return this.baseEditCellAny.destroy_orig();
    }
    else {
      console.log("NumericEdit.destroy incomplete: "+this);
    }
  }

  public read(element: Element): number {
    return this.obj.value;
  }

  private onInputChanged(args: any) {
    var value: string = this.input?.value;
    if (value?.length > 0 && this.obj) {
      /*
      var d: Date = this.localeService.parseDate(value);
      if (d && d != this.obj.value) {
        this.obj.value = d;
        (<any> this.obj).changeTrigger(args);
      }
      */
    }
  }

  private onEditChanged(args: any) {
    if (!this.fieldMeta) {
      return;
    }
    if (this.rowData) {
      FieldMetadataUtil.valueSet(this.rowData, args.value, this.fieldMeta);
    }
    if (!this.fieldMeta.onEditChanged) {
      return;
    }
    var changedArgs: FieldEditChangedArgs = {
      editService: this.grid?.cerGrid?.editService,
      field: this.fieldMeta?.name,
      fieldMeta: this.fieldMeta,
      fieldsMeta: this.fieldsMeta,
      value: args.value,
      previousValue: args.previousValue,
      data: this.rowData,
      args: args
    }
    this.fieldMeta.onEditChanged(changedArgs);
  }

  public onKeyDown(args: any) {
    if (this.fieldMeta?.onKeyDown) {
      this.fieldMeta.onKeyDown(args);
    }
  }

  private cerEventListenerAdd() {

    this.input.addEventListener("keydown", this.onKeyDown.bind(this));
    this.input.addEventListener("change", this.onInputChanged.bind(this));
    this.obj.addEventListener("change", this.onEditChanged.bind(this));
    if (this.noUpDown) {
      EventHandler.remove(this.obj.element, 'keydown', (<any>this.obj).keyDownHandler);
      EventHandler.add(this.obj.element, 'keydown', this.keyDownHandlerUpDown.bind(this));
    }
  };

  private cerEventListenerRemove() {
    if (this.noUpDown) {
      EventHandler.remove(this.obj.element, 'keydown', this.keyDownHandlerUpDown.bind(this));
    }
    if (this.obj) {

      this.obj.removeEventListener("change", this.onEditChanged.bind(this));
    }
    if (this.input) {
      this.input.removeEventListener("change", this.onInputChanged.bind(this));
      this.input.removeEventListener("keydown", this.onKeyDown.bind(this));
    }
  }
}

